module.exports = (__webpack_require__("49fU"))(2);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/index.js from dll-reference vendor_library
// module id = GiK3
// module chunks = 23